import classNames from 'classnames/dedupe'

interface DividerPropsInterface {
  gray: boolean
}

export const Divider = ({ gray }: DividerPropsInterface) => {
  return (
    <div
      style={{ height: 1 }}
      className={classNames([gray && 'my-12 bg-gray-300', !gray && 'my-32 bg-gray-300'])}
    ></div>
  )
}

export const DividerGray200 = ({ gray }: DividerPropsInterface) => {
  return (
    <div
      style={{ height: 1 }}
      className={classNames([gray && 'my-12 bg-gray-200', !gray && 'my-32 bg-gray-200'])}
    ></div>
  )
}

export const MobileDivider = ({ className }: { className?: string }) => {
  return <div className={classNames('border-t-1 h-[8px] w-full border-gray-100 bg-gray-50', className)} />
}
